module.exports = __webpack_public_path__ + "assets/3e64eff2dbecb543690b3e49d2b68696.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/freespin/BgmFg.mp3
 ** module id = 373
 ** module chunks = 0
 **/